// extracted by mini-css-extract-plugin
export default {"collapse":"AnswersListMore-module__collapse--ded0d","trigger":"AnswersListMore-module__trigger--c53ba"};